import React from 'react';

interface Props {
  data: number[];
  color?: string;
  height?: number;
}

/** Lightweight SVG sparkline (line + soft gradient area fill). */
const Sparkline: React.FC<Props> = ({ data, color = 'var(--brand-500)', height = 64 }) => {
  if (!data || data.length < 2) {
    return <div className="dim" style={{ fontSize: 13, padding: '12px 0' }}>Nedovoljno podataka za trend.</div>;
  }
  const W = 100;
  const H = 100;
  const max = Math.max(...data, 1);
  const min = Math.min(...data, 0);
  const range = max - min || 1;
  const step = W / (data.length - 1);
  const pts = data.map((v, i) => [i * step, H - ((v - min) / range) * (H - 10) - 5]);
  const line = pts.map(([x, y]) => `${x},${y}`).join(' ');
  const area = `0,${H} ${line} ${W},${H}`;
  const gradId = 'spark-grad';

  return (
    <svg viewBox={`0 0 ${W} ${H}`} preserveAspectRatio="none" width="100%" height={height} style={{ display: 'block' }}>
      <defs>
        <linearGradient id={gradId} x1="0" y1="0" x2="0" y2="1">
          <stop offset="0%" stopColor={color} stopOpacity="0.25" />
          <stop offset="100%" stopColor={color} stopOpacity="0" />
        </linearGradient>
      </defs>
      <polygon points={area} fill={`url(#${gradId})`} />
      <polyline points={line} fill="none" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" vectorEffect="non-scaling-stroke" />
    </svg>
  );
};

export default Sparkline;
